import type { FC } from 'react';
import { ForEachLoopWrapper } from './ForEachLoop.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface ForEachLoopProps { }

const ForEachLoop: FC<ForEachLoopProps> = () => (
   <ForEachLoopWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">For each loop</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">The Java forEach is a utility method. It helps iterate over a collection such as (list, set, or map) &amp; stream and perform a certain action on each element of it.</p>
         <br/>
         <ul className="text-align-justify">
            <li>A new method forEach() is introduced in Java 8 to iterate over elements.</li>
            <li>It is a default method available in the Iterable interface.</li>
            <li>We can use forEach to iterate over a collection and perform a certain action on each element. </li>
            <li>A class that implements the Consumer interface contains the action and it passes the action as an argument to forEach. </li>
            <li>The Consumer interface is a functional interface with a single abstract method. </li>
            <li>This method accepts a single parameter which is a functional interface. So, one can pass a lambda expression as an argument.</li>
            <li>The method accepts an input and returns no result.</li>
            <li>Maps are not Iterable, however, maps do provide their own variant of forEach that accepts a BiConsumer. </li>
            <li>Iterable’s forEach introduces A BiConsumer instead of a Consumer. As a result,  an action can be performed on both the key and value of a Map simultaneously.</li>
            <li>The forEach loop just needs to know what is to be done and all the work of iterating will be taken care of internally. However, in a traditional loop, we need to tell how to perform the iterations.</li>
         </ul>
         <br/>
         <p className="text-align-justify"><strong>List :</strong></p>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'List <String> names = Arrays.asList("A", "B", "C", "D");\n'+
               'names.forEach(System.out::println);\n'+
               'names.forEach(name -> System.out.println(name));\n'+
               '\n'+
               'ArrayList <String> namesList = new ArrayList <> (names);\n'+
               'Consumer <String> lambdaExp = x -> System.out.println(x.toLowerCase());\n'+
               '\n'+
               'namesList.forEach(name -> System.out.println(name.toLowerCase()));\n'+
               'namesList.forEach(lambdaExp);'
            }
         </SyntaxHighlighter>
         <br/>
         <p className="text-align-justify"><strong>Map :</strong></p>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'HashMap <String, Integer> map = new HashMap <> ();\n'+
               'map.put("A", 1);\n'+
               'map.put("B", 2);\n'+
               'map.put("C", 3);\n'+
               '\n'+
               'Consumer <Map.Entry <String, Integer>> action = System.out::println;\n'+
               'map.entrySet().forEach(action);\n'+
               '\n'+
               'Consumer <String> actionOnKeys = System.out::println;\n'+
               'map.keySet().forEach(actionOnKeys);\n'+
               '\n'+
               'Consumer <Integer> actionOnValues = System.out::println;\n'+
               'map.values().forEach(actionOnValues);\n'+
               '\n'+
               'map.forEach((key, value) -> System.out.println(key + " " + value));'
            }
         </SyntaxHighlighter>
         <br/>
         <p className="text-align-justify"><strong>Stream :</strong></p>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'List <Integer> numberList = Arrays.asList(1, 2, 3, 4, 5);\n'+
               'Consumer <Integer> action = System.out::println;\n'+
               'numberList.stream()\n'+
               '  .filter(n -> n % 2 == 0)\n'+
               '  .filter(action);'
            }
         </SyntaxHighlighter>
      </div>
   </ForEachLoopWrapper>
);

export default ForEachLoop;
